// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthHeader_container_1lFxq","title":"AuthHeader_title_3GmAe","lang":"AuthHeader_lang_2W4ce"};